<div class="menu-mobile">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
    <mat-tree-node *matTreeNodeDef="let node">
      <li class="mat-tree-node" (click)="treeControl.toggle(node)" (mouseleave)="treeControl.toggle(node)">
        <a *ngIf="!node.level" [nbTooltip]="node.title" class="notChild" [ngClass]="{'active': isActive(node)}" [routerLink]="[node.link]">
          <nb-icon class="menu-icon" [icon]="node.icon"/>
          <span *ngIf="node.level">{{ node.title }}</span>
        </a>
        <a *ngIf="node.level" class="notChild" [ngClass]="{'active': isActive(node)}" [routerLink]="[node.link]">
          <nb-icon [icon]="node.icon"></nb-icon>
          <span *ngIf="node.level">{{ node.title }}</span>
        </a>
      </li>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <li (mouseenter)="treeControl.toggle(node)" (mouseleave)="treeControl.toggle(node)">
        <div class="mat-tree-node" [ngClass]="{'active': isActive(node)}">
          <p *ngIf="node.level">{{ node.title }}</p>
          <button [nbTooltip]="node.title" mat-icon-button
                  [attr.aria-label]="'Toggle ' + node.title">
            <nb-icon [icon]="node.icon"></nb-icon>
          </button>
        </div>
        <ul class="nav-menu-mobile" [class.example-tree-invisible]="!treeControl.isExpanded(node)">
          <ng-container matTreeNodeOutlet></ng-container>
        </ul>
      </li>
    </mat-nested-tree-node>
  </mat-tree>
</div>
